// Brings each tab back to the page it was on after the user logs in again, after a timeout or a logout.
//
// Devise also stores a location to return to, but there is one per session: when several tabs are sent to the
// login page the last one wins and every tab would return to that page. sessionStorage belongs to a single tab
// and survives its trip through the login page.
const RETURN_PAGE_KEY = 'afflo:session:returnPage';

// Only pages of the app, not the login pages or the coordinator iframe
function isAppPage(path: string): boolean {
  return path === '/ui' || path.startsWith('/ui/');
}

// Call before this tab leaves the app because the session ended or the user logged out
export function rememberCurrentPage(): void {
  const { pathname, search, hash } = window.location;
  if (!isAppPage(pathname)) return;

  try {
    window.sessionStorage.setItem(RETURN_PAGE_KEY, `${pathname}${search}${hash}`);
  } catch {
    // Ignore, the tab returns to the app's home page
  }
}

// The page to return to once signed in, null when there is none or the tab is already on it. Only returned once.
export function takeReturnPage(): string | null {
  let page: string | null;
  try {
    page = window.sessionStorage.getItem(RETURN_PAGE_KEY);
    window.sessionStorage.removeItem(RETURN_PAGE_KEY);
  } catch {
    return null;
  }

  const { pathname, search, hash } = window.location;
  if (!page || !isAppPage(page.split(/[?#]/)[0]) || page === `${pathname}${search}${hash}`) return null;

  return page;
}
